import React from 'react';
import { List } from 'immutable';
import PropTypes from 'prop-types';

import { Button } from '@els/els-react--button';

function TreeViewDialogFooter(props) {
  const { tags, onClickLimitTo, onClickExclude } = props;

  if (!tags) {
    return null;
  }

  const disableControls = tags.count() === 0;

  return (
    <div className="treeViewDialog__footerActions">
      <Button
        data-e2e="tree-view-exclude"
        type="secondary"
        disabled={disableControls}
        onClick={onClickExclude}
        className="e2e-tree-view-exclude">
        Exclude
      </Button>
      <Button
        data-e2e="tree-view-limit"
        type="primary"
        disabled={disableControls}
        onClick={onClickLimitTo}
        className="e2e-tree-view-limit">
        Limit to
      </Button>
    </div>
  );
}

TreeViewDialogFooter.propTypes = {
  tags: PropTypes.instanceOf(List),
  onClickLimitTo: PropTypes.func.isRequired,
  onClickExclude: PropTypes.func.isRequired,
};

export default TreeViewDialogFooter;
